import { site } from "@/mocks/site";

export default function FloatingActions() {
  return (
    <>
      <a
        href={site.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp'tan yazın"
        className="fixed bottom-6 right-6 z-40 hidden h-14 w-14 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 transition-transform hover:scale-105 md:flex"
      >
        <i className="ri-whatsapp-line text-2xl" aria-hidden="true" />
      </a>

      <nav
        aria-label="Hızlı işlemler"
        className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-background-200 bg-background-50/95 backdrop-blur md:hidden"
      >
        <a
          href={site.phoneMainHref}
          className="flex cursor-pointer flex-col items-center gap-1 py-2.5 text-[11px] font-semibold text-foreground-800"
        >
          <i className="ri-phone-line text-lg text-primary-600" aria-hidden="true" />
          Ara
        </a>
        <a
          href={site.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="flex cursor-pointer flex-col items-center gap-1 border-x border-background-200 py-2.5 text-[11px] font-semibold text-foreground-800"
        >
          <i className="ri-whatsapp-line text-lg text-primary-600" aria-hidden="true" />
          WhatsApp
        </a>
        <a
          href={site.directions}
          target="_blank"
          rel="noopener noreferrer"
          className="flex cursor-pointer flex-col items-center gap-1 py-2.5 text-[11px] font-semibold text-foreground-800"
        >
          <i className="ri-road-map-line text-lg text-primary-600" aria-hidden="true" />
          Yol Tarifi
        </a>
      </nav>
    </>
  );
}